
import ElementModelManager from "../Data/DataManagers/ElementModelManager.js";
import ClashModelManager from "../Data/DataManagers/ClashModelManager.js";
import { getElementById } from "../Experience/World/CustomHighlighter.js";
import {isolateWithClipping} from "../Experience/IFC/IFCMeshHandler.js"
import {resetClipping} from "../Experience/IFC/IFCMeshHandler.js"
import ThreeJSFunctions from "../Experience/Threejs/ThreeJSFunctions.js";
import Experience from "../Experience/Experience.js";


let manager = new ElementModelManager();
let clashmanager = new ClashModelManager();
let experience = null;


export function showOverviewPanel(id) {

    let overview = manager.getModelOverviewById(id);
    //console.log("overview pre clash", overview);
    if(overview === undefined)
    {
      //console.log("We're here!")
        overview = clashmanager.getModelOverviewByUuid(id);
    }
    //console.log("overview post clash", overview);

    // Set the main properties
    document.getElementById("overviewName").textContent = overview.ElementName;
    document.getElementById("overviewID").textContent = overview.ElementID;
    document.getElementById("overviewCategory").textContent = overview.ElementCategory;
    document.getElementById("overviewLinkedFile").textContent = overview.ElementLinkedFile;

    //const tableBody = document.querySelector("#overviewTable tbody");

    const clashlist = clashmanager.getModelsByElementUuid(id)
    //console.log(clashlist);

    const overviewList = [
    { name: overview.ElementCategory, parameters: overview.Parameters, id: overview.ElementID },
    ...(clashlist || []).map(clash => clashmanager.reorganizeClash(clash))
    ];

    //console.log(overviewList)

    showOverviewTabs(overviewList);



    // Show the panel
    document.getElementById("elementviewPanel").style.display = "block";
}

export function hideOverviewPanel() {
  // Clear the main properties
  document.getElementById("overviewName").textContent = "";
  document.getElementById("overviewID").textContent = "";
  document.getElementById("overviewCategory").textContent = "";
  document.getElementById("overviewLinkedFile").textContent = "";

  // Clear the dynamic tabs and content
  document.getElementById("overviewTabs").innerHTML = "";
  document.getElementById("overviewTabContent").innerHTML = "";

  // Hide the panel
  document.getElementById("elementviewPanel").style.display = "none";
  
  resetClipping();
}

// Toggle Button Event Handler
export function toggleIcon() {
    const eyeIcon = document.getElementById("eyeIcon");
    if (eyeIcon.classList.contains("fa-eye")) {
        eyeIcon.classList.remove("fa-eye");
        eyeIcon.classList.add("fa-eye-slash");
        toggleViewForElement(false);
    } else {
        eyeIcon.classList.remove("fa-eye-slash");
        eyeIcon.classList.add("fa-eye");
        toggleViewForElement(true);
    }

    // Trigger the event you want here
    //console.log("Icon toggled");
}

function toggleViewForElement(isVisible)
{

    const elid = document.getElementById("overviewID").textContent;

    const elementmodel = manager.getModelById(elid);
    const clashmodel = clashmanager.getModelByUuid(elid);

    if(elementmodel === undefined & clashmodel === undefined) return;

    if(elementmodel !== undefined) elementmodel.mesh.visible = isVisible;

    if(clashmodel !== undefined) clashmodel.mesh.visible = isVisible;







} 

function filterViewForElement(isFilter)
{

    const elid = document.getElementById("overviewID").textContent;
    console.log("filterViewForElement")
    console.log(elid)
    const elementmodel = manager.getModelByUuid(elid);
    console.log("elementmode", elementmodel)

    const clashmodel = clashmanager.getModelByUuid(elid);
    console.log("clashmodel", clashmodel)

    if(elementmodel === undefined & clashmodel === undefined) return;

    if(isFilter){
        if(elementmodel !== undefined)
            { isolateWithClipping(elementmodel.mesh);}

        if(clashmodel !== undefined)
            { isolateWithClipping(clashmodel.mesh);}

    }else{
        resetClipping();

    }

}


export function filterIcon()
{
    const filtIcon = document.getElementById("filterIcon");

    if(filtIcon.classList.contains("fa-filter")){
        filtIcon.classList.remove("fa-filter");
        filtIcon.classList.add("fa-building")
        filterViewForElement(true)
        
    } else{
        filtIcon.classList.remove("fa-building")
        filtIcon.classList.add("fa-filter")
        filterViewForElement(false)
    }
}

function showOverviewTabs(overviewList) {
const tabButtonsContainer = document.getElementById("overviewTabs");
  const tabContentsContainer = document.getElementById("overviewTabContent");

  tabButtonsContainer.innerHTML = "";
  tabContentsContainer.innerHTML = "";

  overviewList.forEach((overview, index) => {
    console.log(overview)
    const tabId = `tab-${index}`;

    if (!experience) {
        experience = new Experience();
    }

    // Create tab button
    const tabButton = document.createElement("button");
    tabButton.classList.add("tab-button");
    tabButton.textContent = overview.name;
    tabButton.setAttribute("data-tab-target", tabId);
    tabButton.setAttribute("data-mesh-id", overview.id); // store unique mesh key
    if (index === 0) tabButton.classList.add("active"); // Make the first button active
    tabButtonsContainer.appendChild(tabButton);

    // Create tab content
    const tabPane = document.createElement("div");
    tabPane.classList.add("tab-pane");
    tabPane.setAttribute("data-tab-id", tabId);

    if (index === 0) tabPane.classList.add("active"); // Make the first tab pane active
    tabContentsContainer.appendChild(tabPane);

    const table = document.createElement("table");
    table.classList.add("overview-table");

    const paramSets = overview.parameters;
    if (!paramSets || typeof paramSets !== "object") return;

    for (const [propertySet, parameters] of Object.entries(paramSets)) {
      const headerRow = document.createElement("tr");
      const headerCell = document.createElement("td");
      headerCell.colSpan = 2;
      headerCell.classList.add("parameter-header");

      const toggleButton = document.createElement("button");
      toggleButton.classList.add("collapse-toggle");
      toggleButton.setAttribute("aria-expanded", "true");
      toggleButton.innerHTML = `<span class="arrow-icon">&#9660;</span> ${propertySet}`;
      headerCell.appendChild(toggleButton);
      headerRow.appendChild(headerCell);
      table.appendChild(headerRow);

      const parameterContainer = document.createElement("tbody");
      parameterContainer.classList.add("parameter-container");

      parameters.forEach(param => {
        const row = document.createElement("tr");

        const cellName = document.createElement("td");
        cellName.textContent = param.name;

        const cellValue = document.createElement("td");
        cellValue.textContent = param.value;

        row.appendChild(cellName);
        row.appendChild(cellValue);
        parameterContainer.appendChild(row);
      });

      table.appendChild(parameterContainer);

      toggleButton.addEventListener("click", () => {
        
        const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
        toggleButton.setAttribute("aria-expanded", !isExpanded);
        toggleButton.querySelector(".arrow-icon").innerHTML = isExpanded ? "&#9654;" : "&#9660;";
        parameterContainer.style.display = isExpanded ? "none" : "table-row-group";
        
      });
    }

    tabPane.appendChild(table);
  });

  // Add event listener AFTER all buttons are created
  const allButtons = tabButtonsContainer.querySelectorAll("button");
  const allPanes = tabContentsContainer.querySelectorAll(".tab-pane");

  allButtons.forEach(button => {
    button.addEventListener("click", () => {
      const targetId = button.getAttribute("data-tab-target");
      const meshName = button.getAttribute("data-mesh-id");


      // Remove "active" from all buttons and panes
      allButtons.forEach(btn => btn.classList.remove("active"));
      allPanes.forEach(pane => pane.classList.remove("active"));

      // Activate the clicked button and corresponding pane
      button.classList.add("active");
      //console.log("Experience:",experience.getCameraExperience());
      //console.log(button.textContent);
      //console.log("Getmesh:",experience.getMeshfromScene(button.textContent));

      ThreeJSFunctions.fitOrthoPerCameraToCenteredObject(experience.getCameraExperience(), experience.getMeshfromScene(meshName))
      const activePane = tabContentsContainer.querySelector(`.tab-pane[data-tab-id="${targetId}"]`);
      if (activePane) activePane.classList.add("active");
    });
  });
}

